import { SET_VANS_LIST, SET_VANS_PAGE} from "./listVansActions";

const INITIAL_STATE = {
  vansList: null,
  vansPage: 0,

};

const listVansReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_VANS_LIST:
      return {
        ...state,
        vansList: action.payload,
      };

      case SET_VANS_PAGE:
      return {
        ...state,
        vansPage: action.payload,
      };




    default:
      return state;
  }
};

export default listVansReducer;